<div class="container-item-menu" [class.selected]="active">
  <div class="item-menu" [class]="product">
    <img [src]="icon" />
    <label class="item-label">{{ label }}</label>
  </div>
</div>
